/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { reportsColumn } from "../../../components/Shared/Table/Columns";
import { reportFilterSelector, urlParameterReportSelector } from "../../../store/filters/Reports/selectors";
import { useStoreDispatch } from "../../../store/hooks";
import { useGetAllReportsQuery } from "../../../store/api/devices/deviceApiSlice";
import { searchKeywordSelector } from "../../../store/search/selector";
import { API } from "../../../globals/globals";
import { auditReportTypeValues } from "../../../globals/constants";
import { paginationModelSelector } from "../../../store/helpers/helperSelectors";
import { initialState } from "../../../store/helpers/helperInitialState";
import { setDeviceCount } from "../../../store/helpers/helperReducers";

export const useReportDisplay = () => {
  const dispatch = useStoreDispatch();

  const [sortOrder, setSortOrderToReport] = useState("createdTS, desc");
  const [isReportselected, setIsReportSelected] = useState<boolean>(false);


  const filters = useSelector(urlParameterReportSelector);
  const keyword = useSelector(searchKeywordSelector);
  const { reportDisplay = initialState.pagination } = useSelector(paginationModelSelector);

  filters.set("sort", sortOrder);
  filters.set("page", reportDisplay.page.toString());
  filters.set("size", reportDisplay.pageSize.toString());
  filters.set("search", keyword);
  const args = { filters: filters.toString() };

  const { data, isLoading, refetch } = useGetAllReportsQuery(args, {
    pollingInterval: API.ENDPOINTS.ALLREPORTS.pollingInterval || API.POLLING_INTERVAL,
  });

  const normalizeCustomAuditType = (type: string) =>
    type === auditReportTypeValues.customAuditReport ? auditReportTypeValues.customAuditReportLabel : type;

  const normalizeCustomAuditReportName = (reportName: string) => {
    if (!reportName) {
      return reportName;
    }
    if (reportName.startsWith(`${auditReportTypeValues.customAuditReport}_`)) {
      return reportName.replace(
        `${auditReportTypeValues.customAuditReport}_`,
        `${auditReportTypeValues.customAuditReportLabel}_`
      );
    }
    return reportName;
  };

  const rowsData =
    data?.data?.map((row: any) => ({
      ...row,
      type: normalizeCustomAuditType(row?.type || ""),
      reportName: normalizeCustomAuditReportName(row?.reportName || ""),
    })) || [];
  const noOfRows = data?.totalItems || 0;
  const reportFilterData = useSelector(reportFilterSelector);

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    dispatch(
      setDeviceCount({
        disconnectedDeviceCount: Number(localStorage.getItem("disconnected")),
        allDeviceCount: Number(localStorage.getItem("allDevice")),
        inMaintenanceModeCount: Number(localStorage.getItem("inMaintenanceMode")),
        ungroupedCount: Number(localStorage.getItem("ungrouped")),
        kpiSyncErrorCount: Number(localStorage.getItem("kpiErorrCount")),
        offLineDeviceCount: Number(localStorage.getItem("offLineDeviceCount")),
        configMismatchCount: Number(localStorage.getItem("configMismatchCount")),
      })
    );
  }, [dispatch]);

  return {
    dispatch,
    reportsColumn,
    rowsData,
    isLoading,
    noOfRows,
    reportFilterData,
    setSortOrderToReport,
    isReportselected, 
    setIsReportSelected
  };
};
